// src/hooks/useCountries.ts
import { useQuery } from "@tanstack/react-query";
import { api } from "@utils"; // tu axios instance
import { Country, GetCountriesResponse } from "./useGetModelsService/types";
import { getCountries } from "./useGetModelsService/api";

// Si ya tenías un "responseGetter", lo usamos acá:
export const getCountriesResponseGetter = (
  res: GetCountriesResponse
): Country[] => res.countries ?? [];

export function useCountries() {
  return useQuery({
    queryKey: ["countries"],
    queryFn: async () => {
      const { data } = await api.request<GetCountriesResponse>(getCountries());
      return data;
    },
    select: getCountriesResponseGetter, // 👈 aplica tu responseGetter
    staleTime: 1000 * 60 * 10, // 10 min: no re-fetch hasta que venza
    gcTime: 1000 * 60 * 30, // 30 min en caché
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false, // evita refetch al re-montar (React 18 StrictMode)
  });
}
